@app.directive 'collectionNav', (PageService, $stateParams) ->
  restrict: 'E'
  scope: {}
  replace: true
  bindToController:
    collectionId: '@'
  controllerAs: 'collectionNav'
  controller: ($state) ->

    @slug = $stateParams['context']

    handleSuccess = (data) =>
      @content = data

    handleError = (error) ->
      console.log 'Error getting page: ', error

    if @collectionId
      PageService.show {id: @collectionId}, handleSuccess, handleError

    @showComponent = (component) ->
      return false if _.includes ['media', 'text-block', 'hero', 'banner'], component.componentType
      true

    this

  templateUrl: "/assets/templates/directives/collectionNav/collectionNav.html"
